export function RiskResultsEmptyState() {
  return (
    <svg
      width="185"
      height="184"
      viewBox="0 0 185 184"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <title>Complete survey for Risk Results</title>
      <path
        d="M42.8506 18.4922C57.6083 7.50334 75.9033 0.999942 95.7166 0.999942C105.777 0.999942 115.446 2.67683 124.46 5.76532"
        stroke="#043454"
        strokeWidth="1.29189"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeDasharray="8.61 8.61"
      />
      <path
        d="M42.852 160.715C25.9084 148.099 13.6276 129.57 9.06396 108.184"
        stroke="#043454"
        strokeWidth="1.29189"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeDasharray="8.61 8.61"
      />
      <path
        d="M176.862 53.9674C181.659 64.8719 184.321 76.927 184.321 89.603C184.321 115.003 173.632 137.907 156.509 154.062"
        stroke="#043454"
        strokeWidth="1.29189"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeDasharray="8.61 8.61"
      />
      <path
        d="M26.5381 89.603C26.5381 51.3965 57.5102 20.4247 95.7167 20.4247C133.923 20.4247 164.896 51.3965 164.896 89.603C164.896 127.81 133.923 158.782 95.7167 158.782C57.5102 158.782 26.5381 127.81 26.5381 89.603Z"
        fill="#D1D8FF"
      />
      <path
        d="M160.806 16.0595H131.998V54.4287H160.806V16.0595Z"
        fill="white"
        stroke="#043454"
        strokeWidth="0.968921"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M143.407 32.8164H136.638C135.805 32.8164 135.13 32.141 135.13 31.3079V24.2621C135.13 23.429 135.805 22.7535 136.638 22.7535H143.407C144.24 22.7535 144.915 23.429 144.915 24.2621V31.3079C144.915 32.141 144.24 32.8164 143.407 32.8164Z"
        fill="#58D6C3"
      />
      <path
        d="M143.407 32.8164H136.638C135.805 32.8164 135.13 32.141 135.13 31.3079V24.2621C135.13 23.429 135.805 22.7535 136.638 22.7535H143.407C144.24 22.7535 144.915 23.429 144.915 24.2621V31.3079C144.915 32.141 144.24 32.8164 143.407 32.8164Z"
        stroke="#043454"
        strokeWidth="0.968921"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M137.354 27.3282L139.578 30.0723L142.691 25.0408"
        stroke="#043454"
        strokeWidth="0.968921"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M143.407 45.0547H136.638C135.805 45.0547 135.13 44.3792 135.13 43.5461V36.5004C135.13 35.6667 135.805 34.9918 136.638 34.9918H143.407C144.24 34.9918 144.915 35.6667 144.915 36.5004V43.5461C144.915 44.3792 144.24 45.0547 143.407 45.0547Z"
        fill="white"
      />
      <path
        d="M143.407 45.0547H136.638C135.805 45.0547 135.13 44.3792 135.13 43.5461V36.5004C135.13 35.6667 135.805 34.9918 136.638 34.9918H143.407C144.24 34.9918 144.915 35.6667 144.915 36.5004V43.5461C144.915 44.3792 144.24 45.0547 143.407 45.0547Z"
        stroke="#043454"
        strokeWidth="0.968921"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M137.842 37.5658L142.419 42.1426"
        stroke="#043454"
        strokeWidth="0.968921"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M142.419 37.5658L137.842 42.1426"
        stroke="#043454"
        strokeWidth="0.968921"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M20.8586 60.9229V82.0684H13.3452V63.7524"
        stroke="#043454"
        strokeWidth="1.18045"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M28.3718 69.2646V82.0684H20.8584V69.2646"
        stroke="#043454"
        strokeWidth="1.18045"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M43.3989 82.0684H50.9123V67.8224H43.3989V82.0684Z"
        fill="#58D6C3"
      />
      <path
        d="M50.9123 67.8224V82.0684H43.3989V67.8224"
        stroke="#043454"
        strokeWidth="1.18045"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M43.3986 60.5563V82.0684H35.8853V62.5327"
        stroke="#043454"
        strokeWidth="1.18045"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M58.4255 44.2503V82.0684H50.9121V54.9155"
        stroke="#043454"
        strokeWidth="1.18045"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M35.8854 55.7156V82.0684H28.3721V58.5163"
        stroke="#043454"
        strokeWidth="1.18045"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M1 48.2674V84.776C1 85.5326 1.71307 86.1465 2.59234 86.1465H61.9948"
        stroke="#043454"
        strokeWidth="1.18045"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M5.83301 64.7148L17.1027 52.0552L24.6161 55.2573L32.1294 47.2427L43.5546 56.3591L56.178 36.9842"
        stroke="#043454"
        strokeWidth="1.18045"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M13.3457 68.0684V82.0684H5.83301V71.9808"
        stroke="#043454"
        strokeWidth="1.18045"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M58.8387 32.5315L53.0195 36.7704L58.1377 39.0664L58.8387 32.5315L53.0195 36.7704L58.1377 39.0664L58.8387 32.5315Z"
        fill="#58D6C3"
      />
      <path
        d="M58.8387 32.5315L53.0195 36.7704L58.1377 39.0664L58.8387 32.5315Z"
        stroke="#043454"
        strokeWidth="1.18045"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M71.0698 183.146L78.2955 173.79C82.3317 173.179 87.8408 169.787 90.2669 167.611L73.675 152.057C73.1329 152.275 72.8113 152.116 72.6252 151.902C72.4495 151.7 72.3882 151.421 72.4306 151.155L74.3156 138.436C74.6992 137.025 73.883 135.566 72.4925 135.177C71.1022 134.787 69.6641 135.615 69.2805 137.027L69.2811 137.013L63.602 153.709C63.602 153.709 62.4071 159.106 62.3829 160.285C62.3651 161.148 62.4245 162.013 62.5617 162.869C62.597 163.089 62.6374 163.309 62.6832 163.528L62.6828 163.526L55.7764 171.384"
        fill="white"
      />
      <path
        d="M71.0698 183.146L78.2955 173.79C82.3317 173.179 87.8408 169.787 90.2669 167.611L73.675 152.057C73.1329 152.275 72.8113 152.116 72.6252 151.902C72.4495 151.7 72.3882 151.421 72.4306 151.155L74.3156 138.436C74.6992 137.025 73.883 135.566 72.4925 135.177C71.1022 134.787 69.6641 135.615 69.2805 137.027L69.2811 137.013L63.602 153.709C63.602 153.709 62.4071 159.106 62.3829 160.285C62.3651 161.148 62.4245 162.013 62.5617 162.869C62.597 163.089 62.6374 163.309 62.6832 163.528L62.6828 163.526L55.7764 171.384"
        stroke="#043454"
        strokeWidth="1.29189"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M77.0906 162.939L76.3791 163.525C75.1139 164.48 73.4312 165.146 71.853 165.339C71.5085 165.381 71.1689 165.401 70.8398 165.396"
        fill="white"
      />
      <path
        d="M77.0906 162.939L76.3791 163.525C75.1139 164.48 73.4312 165.146 71.853 165.339C71.5085 165.381 71.1689 165.401 70.8398 165.396"
        stroke="#043454"
        strokeWidth="1.29189"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M120.81 182.751L113.98 173.79C109.945 173.179 104.435 169.787 102.01 167.611L118.601 152.057C119.144 152.275 119.465 152.116 119.651 151.902C119.827 151.7 119.888 151.421 119.846 151.155L117.96 138.436C117.577 137.025 118.394 135.566 119.784 135.177C121.174 134.787 122.612 135.615 122.996 137.027L122.995 137.013L128.674 153.708C128.674 153.708 129.869 159.106 129.893 160.285C129.911 161.148 129.852 162.013 129.715 162.869C129.68 163.089 129.639 163.309 129.593 163.528V163.526L136.5 171.384"
        fill="white"
      />
      <path
        d="M120.81 182.751L113.98 173.79C109.945 173.179 104.435 169.787 102.01 167.611L118.601 152.057C119.144 152.275 119.465 152.116 119.651 151.902C119.827 151.7 119.888 151.421 119.846 151.155L117.96 138.436C117.577 137.025 118.394 135.566 119.784 135.177C121.174 134.787 122.612 135.615 122.996 137.027L122.995 137.013L128.674 153.708C128.674 153.708 129.869 159.106 129.893 160.285C129.911 161.148 129.852 162.013 129.715 162.869C129.68 163.089 129.639 163.309 129.593 163.528V163.526L136.5 171.384"
        stroke="#043454"
        strokeWidth="1.29189"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M115.186 162.939L115.897 163.525C117.162 164.48 118.845 165.146 120.423 165.339C120.767 165.381 121.108 165.401 121.437 165.396"
        fill="white"
      />
      <path
        d="M115.186 162.939L115.897 163.525C117.162 164.48 118.845 165.146 120.423 165.339C120.767 165.381 121.108 165.401 121.437 165.396"
        stroke="#043454"
        strokeWidth="1.29189"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path d="M119.89 104.038H72.3584V167.346H119.89V104.038Z" fill="white" />
      <path
        d="M119.89 104.038H72.3584V167.346H119.89V104.038Z"
        stroke="#043454"
        strokeWidth="1.29189"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M90.6216 140.979H109.31"
        stroke="#043454"
        strokeWidth="1.29189"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M90.6216 146.69H109.31"
        stroke="#043454"
        strokeWidth="1.29189"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M90.6216 152.4H109.31"
        stroke="#043454"
        strokeWidth="1.29189"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M90.6216 158.11H109.31"
        stroke="#043454"
        strokeWidth="1.29189"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M86.1489 140.98C86.1489 141.867 85.4299 142.586 84.5429 142.586C83.656 142.586 82.937 141.867 82.937 140.98C82.937 140.093 83.656 139.373 84.5429 139.373C85.4299 139.373 86.1489 140.093 86.1489 140.98Z"
        fill="#58D6C3"
      />
      <path
        d="M86.1489 140.98C86.1489 141.867 85.4299 142.586 84.5429 142.586C83.656 142.586 82.937 141.867 82.937 140.98C82.937 140.093 83.656 139.373 84.5429 139.373C85.4299 139.373 86.1489 140.093 86.1489 140.98Z"
        stroke="#043454"
        strokeWidth="1.29189"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M86.1489 146.691C86.1489 147.578 85.4299 148.296 84.5429 148.296C83.656 148.296 82.937 147.578 82.937 146.691C82.937 145.803 83.656 145.084 84.5429 145.084C85.4299 145.084 86.1489 145.803 86.1489 146.691Z"
        fill="#58D6C3"
      />
      <path
        d="M86.1489 146.691C86.1489 147.578 85.4299 148.296 84.5429 148.296C83.656 148.296 82.937 147.578 82.937 146.691C82.937 145.803 83.656 145.084 84.5429 145.084C85.4299 145.084 86.1489 145.803 86.1489 146.691Z"
        stroke="#043454"
        strokeWidth="1.29189"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M86.1489 152.4C86.1489 153.288 85.4299 154.006 84.5429 154.006C83.656 154.006 82.937 153.288 82.937 152.4C82.937 151.513 83.656 150.794 84.5429 150.794C85.4299 150.794 86.1489 151.513 86.1489 152.4Z"
        fill="#58D6C3"
      />
      <path
        d="M86.1489 152.4C86.1489 153.288 85.4299 154.006 84.5429 154.006C83.656 154.006 82.937 153.288 82.937 152.4C82.937 151.513 83.656 150.794 84.5429 150.794C85.4299 150.794 86.1489 151.513 86.1489 152.4Z"
        stroke="#043454"
        strokeWidth="1.29189"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M86.1489 158.11C86.1489 158.998 85.4299 159.716 84.5429 159.716C83.656 159.716 82.937 158.998 82.937 158.11C82.937 157.223 83.656 156.504 84.5429 156.504C85.4299 156.504 86.1489 157.223 86.1489 158.11Z"
        fill="#58D6C3"
      />
      <path
        d="M86.1489 158.11C86.1489 158.998 85.4299 159.716 84.5429 159.716C83.656 159.716 82.937 158.998 82.937 158.11C82.937 157.223 83.656 156.504 84.5429 156.504C85.4299 156.504 86.1489 157.223 86.1489 158.11Z"
        stroke="#043454"
        strokeWidth="1.29189"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M96.9922 122.114H109.442C109.442 118.676 108.048 115.564 105.795 113.311L96.9922 122.114Z"
        fill="#58D6C3"
      />
      <path
        d="M96.9922 122.114H109.442C109.442 118.676 108.048 115.564 105.795 113.311L96.9922 122.114Z"
        stroke="#043454"
        strokeWidth="1.29189"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M105.795 113.311C103.543 111.058 100.43 109.664 96.992 109.664C90.1167 109.664 84.543 115.238 84.543 122.114C84.543 128.989 90.1167 134.563 96.992 134.563C103.867 134.563 109.442 128.989 109.442 122.114H96.992L105.795 113.311Z"
        fill="#FFD1D8"
      />
      <path
        d="M105.795 113.311C103.543 111.058 100.43 109.664 96.992 109.664C90.1167 109.664 84.543 115.238 84.543 122.114C84.543 128.989 90.1167 134.563 96.992 134.563C103.867 134.563 109.442 128.989 109.442 122.114H96.992L105.795 113.311Z"
        stroke="#043454"
        strokeWidth="1.29189"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
